export default [
  {
    path: '/main/integrador/integrator',
    meta: {
      tag: 'list_integrator_settings',
      name: 'Configurações integrador',
      breadcrumb: 'Configurações integrador',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "integrator-config-list" */ '@/views/main/settings/integrador/integrator/Index.vue'),
    children: [
      {
        path: '',
        name: 'listintegratorsettings',
        meta: {
          tag: 'list_integrator_settings',
          menu: 'settings',
          name: 'Configurações integrador'
        },
        component: () => import(/* webpackChunkName: "financial-vehicles-list" */ '@/views/main/settings/integrador/integrator/List.vue'),
      },
      {
        path: '/main/integrador/integrator/add',
        name: 'addintegratorsettings',
        meta: {
          tag: 'add_integrator_settings',
          menu: 'settings',
          name: 'Adicionar | Configuração Integrador',
          breadcrumb: 'Adicionar Configuração Integrador'
        },
        component: () => import(/* webpackChunkName: "integrator-config-add" */ '@/views/main/settings/integrador/integrator/Add.vue')
      },
      {
        path: '/main/integrador/integrator/:id',
        name: 'editintegratorsettings',
        meta: {
          tag: 'edit_integrator_settings',
          menu: 'settings',
          name: 'Editar | Configuração Integrador',
          breadcrumb: 'Editar Configuração Integrador'
        },
        component: () => import(/* webpackChunkName: "integrator-config-edit" */ '@/views/main/settings/integrador/integrator/Edit.vue')
      }
    ]
  }
]
